import axios from './axios'

export const createCheckoutSession = (data, person_id) => {
  let url = '/stripe/create-checkout-session'
  return axios.postJson(url, data)
}